import { render, staticRenderFns } from "./TsBranchWithSubFilter.vue?vue&type=template&id=9b873a82&scoped=true&"
import script from "./TsBranchWithSubFilter.vue?vue&type=script&lang=js&"
export * from "./TsBranchWithSubFilter.vue?vue&type=script&lang=js&"
import style0 from "./TsBranchWithSubFilter.vue?vue&type=style&index=0&id=9b873a82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b873a82",
  null
  
)

export default component.exports